// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2kBJd","sendOtp":"AuthorizeToLogin_sendOtp__3tChq"};